
import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    text-decoration: none;
    //box-sizing: border-box
  }

  body {
    font-size: 20px;
    font-family: 'Inter', sans-serif !important;
    background-color: ${props => props.theme.colors.background} !important;
   

  }

  button {
    cursor: pointer;
  }

  // Adicione quais mais regras desejar!
`;